<template>
	<div class="section_wrap">
		<h6 class="--blue70">
      {{ $t( 'report.components.c_c_complain' ) }}
    </h6>
		<div class="section_body">
			<KvTable class="table" :items="chiefComplainSectionItems"/>
		</div>
	</div>
</template>

<script>
//cc 상세보기 섹션. 우선은 간단하게 입력필드에 받게 해두었음.
import KvTable from '@/components/Table/kvTable'
import { _CHIEF_COMPLAIN_SECTION_TABLE } from
        "@/components/body/myPatient/report/reportItem/chiefComplainSection/lib"
import { mapActions } from "vuex";

export default {
  name: "ChiefComplainSection",
  components: {KvTable},
  data() {
    return {
      chiefComplainSectionItems: new _CHIEF_COMPLAIN_SECTION_TABLE(this)
    }
  },
  methods: {
    ...mapActions(['updateChiefComplainData']),
  },
  mounted() {
    this.chiefComplainSectionItems[0].parentClass = ['columns_4'];
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'resetReportToVuex' || mutation.type === 'setChiefComplainDataToVuex')
        this.chiefComplainSectionItems[0].values = state.report.chiefComplainData;
    })
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  watch: {
    chiefComplainSectionItems: {
      deep: true,
      handler(newData) {
        //무언가 값을 입력하면 뷰엑스에 다소 무식하게 쑤셔넣고있음.
        //lazy insert가 된다면 부담이 덜 할거같은데..
        this.updateChiefComplainData(newData[0].values)
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/scss/default.scss';

.section_wrap {
  @each $key, $value in $flex-column-stretch-all {
		#{$key} : #{$value};
  }
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;

  & .section_body {
    height: 100%;
    margin-top: 25px;

    & .table {
      height: inherit;
      flex-direction: row;
      grid-template-rows: 100%;

      .height_100 {
        height: 100%;
      }
    }
  }
}
</style>